export const SET_FEATURES = "SET_FEATURES";



// WEBPACK FOOTER //
// ./template/state/modules/features/constants.js